import { ArrowRight, MonitorUp, ScanLine, Tag, Zap } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
    {
        icon: ScanLine,
        label: "Scan or Upload",
        testid: "process-step-scan-upload",
        video: {
            webm: "/assets/scan-animation.webm",
            mp4: "/assets/scan-animation.mp4",
        },
    },
    {
        icon: Tag,
        label: "Add Your Offer",
        testid: "process-step-add-offer",
        video: {
            webm: "/assets/offer-animation.webm",
            mp4: "/assets/offer-animation.mp4",
        },
    },
    {
        icon: Zap,
        label: "Generate",
        testid: "process-step-generate",
        video: {
            webm: "/assets/generate-animation.webm",
            mp4: "/assets/generate-animation.mp4",
        },
    },
    {
        icon: MonitorUp,
        label: "Publish",
        testid: "process-step-publish",
        video: {
            webm: "/assets/publish-animation.webm",
            mp4: "/assets/publish-animation.mp4",
        },
    },
];

export const ProcessStrip = () => (
    <section
        className="overflow-hidden bg-white py-20 lg:py-28"
        data-testid="simple-process-section"
    >
        <Reveal className="mb-14 px-4 text-center sm:mb-16">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-teal-700">
                Simple Process
            </p>
            <h2 className="font-display mx-auto mt-3 max-w-3xl text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                Create Your Ad in Four Simple Steps
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-slate-500 sm:text-lg">
                Create and publish professional ads in four simple steps — no design
                skills required.
            </p>
        </Reveal>

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                {STEPS.map((step, i) => (
                    <Reveal key={step.label} delay={i} className="h-full">
                        <div className="relative h-full">
                            <div
                                data-testid={step.testid}
                                className="group flex h-full flex-col items-center justify-center gap-6 rounded-3xl border border-teal-900/5 bg-[#f0fdfa] px-6 py-14 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-teal-200 hover:shadow-xl hover:shadow-teal-900/10"
                            >
                                <span className="font-display absolute left-6 top-5 text-base font-bold text-teal-600/70">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div className="flex h-60 items-center justify-center">
                                    {step.video ? (
                                        <video
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            preload="auto"
                                            className="h-60 w-auto rounded-2xl object-cover shadow-lg ring-1 ring-teal-100"
                                        >
                                            <source src={step.video.webm} type="video/webm" />
                                            <source src={step.video.mp4} type="video/mp4" />
                                        </video>
                                    ) : (
                                        <span className="flex h-24 w-24 items-center justify-center rounded-2xl bg-white text-teal-600 shadow-md ring-1 ring-teal-100 transition-transform duration-300 group-hover:scale-110">
                                            <step.icon className="h-11 w-11" />
                                        </span>
                                    )}
                                </div>
                                <span className="font-display text-xl font-bold text-slate-900">
                                    {step.label}
                                </span>
                            </div>
                            {i < STEPS.length - 1 && (
                                <ArrowRight
                                    className="absolute -right-7 top-1/2 z-10 hidden h-7 w-7 -translate-y-1/2 text-teal-500 lg:block"
                                    strokeWidth={2.5}
                                />
                            )}
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
